import { ApiModule } from '@common/index';

export class NewExportApi extends ApiModule {
  protected endpoint = '/export-data';

  public loadTutorExportDetails() {
    return this.api.get<Blob>(`${this.endpoint}/tutor/xls`, {
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'blob'
    });
  }

  public loadMonthlyReportExportDetails(dataFormValue: any) {
    return this.api.get<Blob>(`${this.endpoint}/monthly-report/xls`, {
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'blob',
      params: {
        specialityList: dataFormValue['specialityList'],
        legislationList: dataFormValue['legislationList'],
        educationStatusList: dataFormValue['educationStatusList'],
        fromDate: dataFormValue['fromDate'],
        toDate: dataFormValue['toDate']
      }
    });
  }

  public loadCandidateWithoutReportExportDetails(dataFormValue: any) {
    return this.api.get<Blob>(`${this.endpoint}/candidate-without-report/xls`, {
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'blob',
      params: {
        specialityList: dataFormValue['specialityList'],
        legislationList: dataFormValue['legislationList'],
        educationStatusList: dataFormValue['educationStatusList'],
        fromDate: dataFormValue['fromDate'],
        toDate: dataFormValue['toDate']
      }
    });
  }

  public loadPersonWithoutCourseExportDetails(dataFormValue: any) {
    return this.api.get<Blob>(`${this.endpoint}/person-without-course/xls`, {
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'blob',
      params: {
        courseList: dataFormValue['courseList'],
        specialityList: dataFormValue['specialityList'],
        educationStatusList: dataFormValue['educationStatusList'],
        legislationList: dataFormValue['legislationList']
      }
    });
  }

  public loadPersonWithCourseExportDetails(dataFormValue: any) {
    return this.api.get<Blob>(`${this.endpoint}/person-with-course/xls`, {
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'blob',
      params: {
        courseList: dataFormValue['courseList'],
        specialityList: dataFormValue['specialityList'],
        educationStatusList: dataFormValue['educationStatusList'],
        legislationList: dataFormValue['legislationList']
      }
    });
  }

  public loadCandidateExportDetails(dataFormValue: any) {
    return this.api.get<Blob>(`${this.endpoint}/candidate/xls`, {
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'blob',
      params: {
        specialityList: dataFormValue['specialityList'],
        legislationList: dataFormValue['legislationList'],
        educationStatusList: dataFormValue['educationStatusList'],
        educationTypeList: dataFormValue['educationTypeId'],
        educationFormList: dataFormValue['educationFormId'],
        specialityGroupList: dataFormValue['specialityGroupList'],
        absolutoriumFromDate: dataFormValue['absolutoriumFromDate'],
        absolutoriumToDate: dataFormValue['absolutoriumToDate'],
        entryFromDate: dataFormValue['entryFromDate'],
        entryToDate: dataFormValue['entryToDate']
      }
    });
  }

  public loadUnclosedMonthsExportDetails(dataFormValue: any) {
    return this.api.get<Blob>(`${this.endpoint}/unclosed-months/xls`, {
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'blob',
      params: {
        fromDate: dataFormValue['fromDate'],
        toDate: dataFormValue['toDate']
      }
    });
  }
}
